import React, { useState, useEffect } from "react";
import { FaUsers } from "react-icons/fa";
import { useApiRequestMutation } from "../../services/apiService";


const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState({
    totalUsers: 0,
    activeUsers: 0,
    percentage: 0
  });
  const [apiRequest] = useApiRequestMutation();

  const fetchDashboardMetrics = async () => {

    try {

      const res = await apiRequest({
        url: "/admin/getDashboardMetrics",
        method: "GET"
      }).unwrap();

      console.log("dashboard response", res);

      const userData = res?.data?.user_management || {};


      setDashboardData({
        totalUsers: userData?.total_users || 0,
        activeUsers: userData?.active_users || 0,
        percentage: userData?.active_users_percentage || 0
      });

    } catch (error) {

      console.error("Dashboard API Error:", error);

      setDashboardData({
        totalUsers: 0,
        activeUsers: 0,
        percentage: 0
      });

    }

  };
  useEffect(() => {
    fetchDashboardMetrics();
  }, []);
  return (
    <div>
      {/* Breadcrumb for this page */}
      <div className="page-header">
        <div className="page-header-left d-flex align-items-center">
          <ul className="breadcrumb mb-0">
            <li className="breadcrumb-item">Dashboard</li>
            <li className="breadcrumb-item active">Home</li>
          </ul>
        </div>
      </div>
      <div className="main-content">

        <div className="row">

          {/* Invoices Awaiting Payment */}
          <div className="col-xxl-3 col-md-6">
            <div className="card stretch stretch-full">
              <div className="card-body">
                <div className="d-flex align-items-start justify-content-between mb-4">
                  <div className="d-flex gap-4 align-items-center">
                    <div className="avatar-text avatar-lg bg-gray-200">
                      <FaUsers size={24} />
                    </div>
                    <div>
                      <div className="fs-4 fw-bold text-dark">
                        <span className="counter">{dashboardData.activeUsers}</span>/<span className="counter">{dashboardData.totalUsers}</span>
                      </div>
                      <h3 className="fs-13 fw-semibold text-truncate-1-line">
                        User Management
                      </h3>
                    </div>
                  </div>
                  {/* <a href="#">
                    <FiMoreVertical />
                  </a> */}
                </div>
                <div className="pt-4">
                  <div className="d-flex align-items-center justify-content-between">
                    <a href="#" className="fs-12 fw-medium text-muted text-truncate-1-line">
                      Active Users
                    </a>
                    <div className="w-100 text-end">
                      {/* <span className="fs-12 text-dark">$5,569</span> */}
                      {/* <span className="fs-11 text-muted">56%</span> */}
                      <span className="fs-11 text-muted">{dashboardData.percentage}%</span>
                    </div>
                  </div>
                  <div className="progress mt-2 ht-3">
                    <div className="progress-bar bg-primary" role="progressbar" style={{ width: `${dashboardData.percentage}%` }}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>



        </div>
      </div>
    </div>
  );
};

export default Dashboard;